import { Box, Checkbox, FormControlLabel } from '@material-ui/core';
import DelegationStatement from 'components/common/DelegationStatemet';
import { Conditional } from 'common/components/layout';
import { get, map } from 'lodash';

const TITLE = 'Delegations that Require New P.I. Signature';
const DISCLAIMER = `Signature requests are automatically generated for any delegations that will be under the
tenure of the new PI. You can deselect delegations that don’t require a new P.I. signature.`;


export default function NewPISignatureForExistingDelegation({ delegationRequiringNewPISignature, onToggleNewPiSignatureForExistingDelegation, styles }){
    return (
        <Conditional condition={get(delegationRequiringNewPISignature, 'length') !== 0}>
            <section className={styles.NewPISignatureForExistingDelegation}>
                <h5>{TITLE}</h5>
                <DelegationStatement type="warning" size="small">
                    <span>
                        {DISCLAIMER}
                    </span>
                </DelegationStatement>
                <Box className={styles.newPISignatures} component='div'>
                    {map(delegationRequiringNewPISignature, ({ id, label, checked }) => (
                        <FormControlLabel
                            key={id}
                            control={
                                <Checkbox
                                    disableRipple
                                    color="primary"
                                    checked={checked}
                                    onChange={() => onToggleNewPiSignatureForExistingDelegation(id)}
                                />
                            }
                            label={label}
                        />
                    ))}
                </Box>
            </section>
        </Conditional>
    );
};